import {
  DataGrid as Grid,
  GridColumnProps,
  LinkColumn,
  SelectFilterComponent,
  SelectFloatingFilterComponent,
} from '@roc/ui';
import { observer } from 'mobx-react';
import React from 'react';
import { useStore } from '@roc/client-portal-shared/hooks';
import { useLoanRoutes } from '@roc/feature-loans-routes-config';
import { useState } from 'react';
import { Box } from '@material-ui/core';
import { InformationDialog } from '@roc/ui';

const columns: GridColumnProps[] = [
  {
    field: 'loanId',
    headerName: 'Loan Id',
    maxWidth: 120,
    cellRenderer: 'loanIdCellRenderer',
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    pinned: 'left',
    lockPinned: true,
  },
  {
    field: 'closingConditionTitle',
    headerName: 'Condition Name',
    minWidth: 220,
    cellRenderer: 'conditionNameCellRenderer',
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'assignee',
    headerName: 'Assignee',
    minWidth: 180,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'taskStatus',
    headerName: 'Status',
    minWidth: 160,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'creationDate',
    headerName: 'Date Created',
    minWidth: 160,
    filter: 'agDateColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'expectedClosingDate',
    headerName: 'Closing Date',
    minWidth: 160,
    filter: 'agDateColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
];

export const PostClosingConditionsTasksGrid = observer(() => {
  const { closingConditionsDashboardStore, globalStore } = useStore();
  const { loanRoutesConfig } = useLoanRoutes();
  const { closingConditionsGridStore } = closingConditionsDashboardStore;
  const [isViewConditionOpen, setIsViewConditionOpen] = useState(false);
  const [selectedCondition, setSelectedCondition] = useState<any>(null);

  const frameworkComponents = {
    selectFilter: SelectFilterComponent,
    selectFloatingFilter: SelectFloatingFilterComponent,
    loanIdCellRenderer: (params: any) => {
      return globalStore.isInternalPortal ?
        LinkColumn({
          ...params,
          onClick: () => { window.parent.postMessage({ loanId: params.node.data?.loanId }, '*'); },
        }) :
        LinkColumn({
          ...params,
          url: loanRoutesConfig.loans(params.value).children.dashboard.url,
        });
    },
    conditionNameCellRenderer: (params: any) =>
      LinkColumn({
        ...params,
        url: '#',
        onClick: (e: any) => {
          e.preventDefault();
          setSelectedCondition(params.node.data);
          setIsViewConditionOpen(true);
        },
      }),
  };

  const onSortChanged = (params: any) => {
    const sortModel = params.api.getSortModel();
    closingConditionsGridStore.setSortModel(sortModel);
  };

  const onFilterChanged = (params: any) => {
    const filterModel = params.api.getFilterModel();
    closingConditionsGridStore.setFilterModel(filterModel);
  };

  return (
    <>
      <Grid
        columns={columns}
        rows={closingConditionsGridStore.gridData.data.rows}
        frameworkComponents={frameworkComponents}
        onSortChanged={onSortChanged}
        onFilterChanged={onFilterChanged}
        isLoading={closingConditionsGridStore.isLoading}
        showFilters={closingConditionsGridStore.showFilters}
        sortModel={closingConditionsGridStore.sortModel}
        filterModel={closingConditionsGridStore.filterModel}
        paginationData={closingConditionsGridStore.gridData.meta}
        setPageNumber={closingConditionsGridStore.setPageNumber}
      />

      <InformationDialog
        open={isViewConditionOpen}
        title="Post-Closing Condition"
        handleClose={() => setIsViewConditionOpen(false)}
        body={
          <Box>
            <strong>Condition Name:</strong> {selectedCondition?.closingConditionTitle} <br />
            <strong>Description:</strong> {selectedCondition?.closingConditionDescription}
          </Box>
        }
      />
    </>
  );
});
